import * as React from "react";

import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export function Rc2ColumnMenu(props: GridColumnMenuProps) {
  const data = [{ Rc2Flag: "Yes" }, { Rc2Flag: "No" }];

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      {...props}
      data={data}
      searchBox={() => null}
    />
  );
}
